import { render, staticRenderFns } from "./StockTicker.vue?vue&type=template&id=2c31465e&scoped=true&"
import script from "./StockTicker.vue?vue&type=script&lang=js&"
export * from "./StockTicker.vue?vue&type=script&lang=js&"
import style0 from "./StockTicker.vue?vue&type=style&index=0&id=2c31465e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31465e",
  null
  
)

export default component.exports